import {
  BOVIO_FIRST_PROFILE,
  OFFER_MODE_ORIGIN_ID,
  type OfferMode,
  OTA_MODE_PROFILE
} from '@vio/core/src/profile/constants'

import {makeGetSearchParameter} from './generic'

/**
 * Get the originId based on environment flags and query parameters.
 *
 * Precedence:
 *  1. Offer mode override
 *  2. BoVio first profile (mutually exclusive with OTA mode upstream)
 *  3. Explicit `profile` URL param
 *  4. Sticky OTA Mode: carries `OTA_MODE_PROFILE` for the rest
 *     of the browser session after the first OTA-profile land
 */
export const getOriginId = (
  queryParams: URLSearchParams,
  useBoVioFirstProfile: boolean,
  isStickyOtaMode = false,
  offerModeOverride: OfferMode | null = null
): string | undefined => {
  const getParameter = makeGetSearchParameter(queryParams)

  if (offerModeOverride) return OFFER_MODE_ORIGIN_ID[offerModeOverride]

  if (useBoVioFirstProfile) {
    return BOVIO_FIRST_PROFILE
  }

  const profileFromUrl = getParameter('profile')
  if (profileFromUrl) return profileFromUrl
  if (isStickyOtaMode) return OTA_MODE_PROFILE

  return undefined
}
